import React, { useState } from "react";
import { CreditCardSubSectionConfig } from "../../constants/PaymentOptions.constants";
import styles from "../../../SubSectionWrapper/SubSectionWrapperStyles.module.css";
import { RequestVerificationStripe } from "../../../SubSectionWrapper/modules/RequestVerificationStripe/RequestVerificationStripe";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { getSectionStates } from "features/AdminPanel/utils/AdminPanel.utils";
import { PAYMENT_OPTION_KEYS } from "../../constants/PaymentOptions.constants";
import { SubSectionLocked } from "../../../SubSectionWrapper/modules/SubSectionLocked/SubSectionLocked";
import classnames from "classnames";
import UnlockedStyles from "../../../SubSectionWrapper/modules/SubSectionUnlocked/SubSectionUnlockedStyles.module.css";
import { SubSectionText } from "features/AdminPanel/modules/SubSectionText/SubSectionText";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";

export const CreditCardSubSection = () => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);

  const diner_card = PAYMENT_OPTION_KEYS.DINERS_CARD;
  const credit_card = PAYMENT_OPTION_KEYS.CREDIT_CARD;
  const amex_card = PAYMENT_OPTION_KEYS.AMEX_CARD;

  const {
    isPlanLocked: isCreditCardLocked,
    verificationNotCompleted: CreditCardNotVerified,
    disableSwitch: credit_disableSwitch,
  } = getSectionStates({ status: sectionConfig[credit_card]?.status });

  const {
    verificationNotCompleted: AmexNotVerified,
    disableSwitch: amex_disableSwitch,
  } = getSectionStates({ status: sectionConfig[amex_card]?.status });

  const {
    verificationNotCompleted: DinerNotVerified,
    disableSwitch: diner_disableSwitch,
  } = getSectionStates({ status: sectionConfig[diner_card]?.status });

  const { handleSectionChange } = useAccountSectionUnlocking();

  const handleChange = (key, value) => {
    const payload = {
      feature_key: key,
      feature_value: !value,
    };
    handleSectionChange({ payload });
  };

  const [creditCardEnabled, setCreditCardEnabled] = useState(
    sectionConfig[credit_card]?.value
  );

  return (
    <div className={styles.wrapper}>
      {isCreditCardLocked || CreditCardNotVerified ? (
        <SubSectionLocked subSection={CreditCardSubSectionConfig.CREDIT_CARD} />
      ) : (
        <div className="!tw-border-0">
          <div className={UnlockedStyles.wrapper}>
            <div className={classnames(UnlockedStyles.subSectionInnerWrapper)}>
              <SubSectionText
                subSectionConfig={{ ...CreditCardSubSectionConfig.CREDIT_CARD }}
              />
              <SectionUnlockingSwitch
                value={creditCardEnabled}
                onChange={() => {
                  handleChange(credit_card, creditCardEnabled);
                  setCreditCardEnabled((prev) => !prev);
                }}
                disabled={credit_disableSwitch}
              />
            </div>
            {CreditCardNotVerified && (
              <div className="tw-flex tw-flex-col tw-w-[90%] tw-mx-5 md:tw-mx-8 tw-mb-6 tw-mt-2 md:tw-mt-[-1.5rem]">
                <RequestVerificationStripe config={{ key: credit_card }} />
              </div>
            )}
          </div>
        </div>
      )}
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isCreditCardLocked || CreditCardNotVerified
            ? "tw-h-0 tw-w-0"
            : "tw-h-auto tw-w-[100%]"
        }`}
      >
        <div className={UnlockedStyles.wrapper}>
          <div className={classnames(UnlockedStyles.subSectionInnerWrapper)}>
            <SubSectionText
              subSectionConfig={{ ...CreditCardSubSectionConfig.AMEX_CARD }}
            />
            <SectionUnlockingSwitch
              value={sectionConfig[amex_card]?.value}
              onChange={() =>
                handleChange(amex_card, sectionConfig[amex_card]?.value)
              }
              disabled={creditCardEnabled ? amex_disableSwitch : true}
            />
          </div>
          {AmexNotVerified && (
            <div className="tw-flex tw-flex-col tw-w-[90%] tw-mx-5 md:tw-mx-8 tw-mb-6 tw-mt-2 md:tw-mt-[-1.5rem]">
              <RequestVerificationStripe config={{ key: amex_card }} />
            </div>
          )}
        </div>

        <div className={UnlockedStyles.wrapper}>
          <div className={classnames(UnlockedStyles.subSectionInnerWrapper)}>
            <SubSectionText
              subSectionConfig={{ ...CreditCardSubSectionConfig.DINER_CARD }}
            />
            <SectionUnlockingSwitch
              value={sectionConfig[diner_card]?.value}
              onChange={() =>
                handleChange(diner_card, sectionConfig[diner_card]?.value)
              }
              disabled={creditCardEnabled ? diner_disableSwitch : true}
            />
          </div>
          {DinerNotVerified && (
            <div className="tw-flex tw-flex-col tw-w-[90%] tw-mx-5 md:tw-mx-8 tw-mb-6 tw-mt-2 md:tw-mt-[-1.5rem]">
              <RequestVerificationStripe config={{ key: diner_card }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
